import * as React from "react";
import { SVGProps } from "react";

const Aeon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 394 379" {...props}>
    <ellipse
      cx={188.8}
      cy={189.7}
      fill="#5fbcd3"
      rx={198.2}
      ry={94.7}
      transform="rotate(-70.7 188.8 189.6)"
    />
    <ellipse
      cx={188.8}
      cy={189.7}
      fill="#2c89a0"
      rx={198.2}
      ry={94.7}
      transform="rotate(-37 188.8 189.7)"
    />
    <ellipse
      cx={197.4}
      cy={184.5}
      fill="#164450"
      rx={198.2}
      ry={94.7}
      transform="rotate(-5.7 197.6 184.6)"
    />
    <path
      fill="#fff"
      d="M211.4 193.4q2.4 23.8 34.1 23.7a77.4 77.4 0 0 0 35.9-8.4v24q-18.9 8.3-45.7 8.3-32.5 0-48-19h-.6q-17 19-43.7 19-20.1 0-31.4-8.8t-11.3-24.4q0-15.5 11.7-24.9t33.4-10.8l31-2.2q0-20.3-22.3-20.3-21 0-41.6 11.4v-25.1a118.5 118.5 0 0 1 44.7-9.1q28.3 0 39.2 14.2h.5a72.3 72.3 0 0 1 38.2-17.5c16.4-2.7 37.1-2.5 47 6.9a35 35 0 0 1 10.3 20.2 32.6 32.6 0 0 1-29.9 36.8zm-34.7.9v-4.8l-18.8 1.4q-22.3 1.6-22.3 14a10.6 10.6 0 0 0 4.8 8.7q4.7 3.5 12.3 3.6 10.4 0 17.2-6.4t6.8-16.5zm38.1-23.3-.3 4.8 19-.6q22.3-.6 23-13a10.4 10.4 0 0 0-4.3-9q-4.5-3.6-12-4-10.4-.4-17.6 5.7t-7.8 16.1z"
    />
  </svg>
);

export default Aeon;
